import React from 'react';

import GetWithdrawalDetailsResponse from '../../../Api/CRM/Responses/WithdrawalDetailsResponse';
import * as formatters from '../../../utils/formatters';
import ProtectedLink from '../../elements/ProtectedLink';
import BooleanIcon from '../../elements/booleanIcon';
import Card from '../../elements/common/Card';
import ColoredStatus from '../../elements/common/ColoredStatus';
import Row, { TableDetailsBody } from '../../elements/common/TableDetailsRow';

import { PERMISSION } from 'crm/helpers/Permissions';

function WithdrawalDetails({ withdrawal }: { withdrawal: GetWithdrawalDetailsResponse }) {
    const { formatDateStringWithTimezone, formatCurrency } = formatters;

    return (
        <Card title="Withdrawal details">
            <TableDetailsBody>
                <Row label="Token">{withdrawal.token}</Row>
                <Row label="Email">
                    <ProtectedLink
                        url={`/users/${withdrawal.user_id}`}
                        value={withdrawal.email}
                        permissions={[PERMISSION.VIEW_USER]}
                    />
                </Row>
                <Row label="KYC confirmed">
                    <BooleanIcon value={withdrawal.kyc_confirmed} />
                </Row>
                <Row label="Name">{withdrawal.user_name}</Row>
                <Row label="Surname">{withdrawal.user_last_name}</Row>
                <Row label="Phone">{withdrawal.phone}</Row>
                <Row label="User fee">{formatCurrency(withdrawal.user_fee)}</Row>
                <Row label="Cost">{formatCurrency(withdrawal.cost)}</Row>
                <Row label="Transaction out ID">{withdrawal.transaction_out_id}</Row>
                <Row label="Transaction currency code">{withdrawal.transaction_currency_code}</Row>
                <Row label="Currency code">{withdrawal.currency_code}</Row>
                <Row label="IP address">{withdrawal.ip_address}</Row>
                <Row label="Withdrawal method">{withdrawal.method_name}</Row>
                <Row label="Amount">{formatCurrency(withdrawal.amount)}</Row>
                <Row label="Status">
                    <ColoredStatus status={withdrawal.status} />
                </Row>
                <Row label="Date confirmed">{formatDateStringWithTimezone(withdrawal.date_confirmed)}</Row>
                <Row label="Created">{formatDateStringWithTimezone(withdrawal.created_at)}</Row>
                <Row label="Data">
                    <code>{JSON.stringify(withdrawal.data)}</code>
                </Row>
            </TableDetailsBody>
        </Card>
    );
}

export default WithdrawalDetails;
